import _objectSpread from "/codebuild/output/src2081543335/src/cocoo_gov/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _slicedToArray from "/codebuild/output/src2081543335/src/cocoo_gov/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regenerator from "/codebuild/output/src2081543335/src/cocoo_gov/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/codebuild/output/src2081543335/src/cocoo_gov/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import useSWRV from "swrv";
import { getData, deleteData } from "@/services/axios";
import { cdate } from "@/utils/cdate";

import { inject, computed, watch } from 'vue';
import { isAuthenticatedKey, meKey } from '/codebuild/output/src2081543335/src/cocoo_gov/src/utils/injectionKey.js';
import { useRoute, useRouter } from 'vue-router/composables';
import { useToggle } from '@vueuse/core';
export default {
  __name: 'ForumShow',
  setup: function setup(__props) {
    // @ts-check
    var isAuthenticated = inject(isAuthenticatedKey);
    var me = inject(meKey);
    var route = useRoute();
    var router = useRouter();
    var _useSWRV = useSWRV(function () {
        return isAuthenticated.value && "forum/".concat(route.params.id);
      }, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var result;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return getData("government_forum/".concat(route.params.id));
            case 1:
              result = _context.v;
              return _context.a(2, result.items);
          }
        }, _callee);
      })), {
        refreshInterval: 0,
        revalidateOnFocus: false
      }),
      data = _useSWRV.data;
    var selectSchoolIdList = computed(function () {
      return data.value.school.map(function (v) {
        return v.id;
      });
    });
    var _useToggle = useToggle(),
      _useToggle2 = _slicedToArray(_useToggle, 2),
      isShowDeleteConfirmModal = _useToggle2[0],
      toggleIsShowDeleteConfirmModal = _useToggle2[1];
    var deleteForum = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return deleteData("government_forum/".concat(route.params.id));
            case 1:
              router.push({
                name: "ForumIndex"
              });
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t = _context2.v;
              console.log(_t);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, null, [[0, 2]]);
      }));
      return function deleteForum() {
        return _ref2.apply(this, arguments);
      };
    }();
    var _useSWRV2 = useSWRV(function () {
        return isAuthenticated.value && "forum";
      }, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var result;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return getData("government_forum", {
                exclude: route.params.id
              });
            case 1:
              result = _context3.v;
              return _context3.a(2, result.items);
          }
        }, _callee3);
      })), {
        revalidateOnFocus: false
      }),
      forumList = _useSWRV2.data,
      mutate = _useSWRV2.mutate;
    var dataForCopy = computed(function () {
      var keysToRemove = ["id", "school_ids", "school", "email_status"];
      var newObj = _objectSpread({}, data.value);
      keysToRemove.forEach(function (key) {
        delete newObj[key];
      });
      if (newObj["email_status"]) {
        newObj["email_status"] = "pending";
      }
      return newObj;
    });
    watch(function () {
      return route.params.id;
    }, function () {
      mutate();
    });
    return {
      __sfc: true,
      isAuthenticated: isAuthenticated,
      me: me,
      route: route,
      router: router,
      data: data,
      selectSchoolIdList: selectSchoolIdList,
      isShowDeleteConfirmModal: isShowDeleteConfirmModal,
      toggleIsShowDeleteConfirmModal: toggleIsShowDeleteConfirmModal,
      deleteForum: deleteForum,
      forumList: forumList,
      mutate: mutate,
      dataForCopy: dataForCopy,
      cdate: cdate
    };
  }
};